/* eslint-disable*/
import React from 'react';
import {
  Box,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import { styled } from '@mui/system';

/* import useStyles from '../../screens/Main/Main.style'; */
import useStyles from './CustomDropdown.style';

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({}));

const CustomDropdown = ({ options, label, value, onChange }) => {
  const classes = useStyles();

  return (
    <Box className={classes.CompanyOperationalPerformanceFilter} width="150px">
      <FormControl fullWidth>
        <Select value={value} onChange={onChange}>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <ListItemIcon>{option.icon}</ListItemIcon>
              <ListItemText primary={option.label} className={classes.CustomMenuItemText} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default CustomDropdown;
